import ProductCards from "../ProductCards/ProductCards";
import styles from "./productCarousel.module.scss";
import labels from "../../../config/labels";
import { CustomContainer, OwlCarousel } from "../../atoms/DependencyHelper";
import CarouselButton from "../../atoms/buttons/carouselButton/CarouselButton";
import { useState, useEffect } from "react";
import { productCarouselService } from "../../../services/pageService";
import {
  getPromotionLabel,
  getPromotionVariant,
  componentCheckSize,
  getPlanNameLabel,
} from "../../../utils/helperServices";
import {
  checkIsLowStock,
  checkIsOutOfStock,
  checkIsFinalPriceReq,
  getFinalPrice,
  getPercentOffValue,
  getAmountOffValue,
  getHighlights,
  getRegularPrice,
  getDealExpiryTime,
  getProductImageUrl,
} from "../../../utils/helperServices";
import DealCard from "../dealCard/DealCard";
import * as Analytics from "../../../services/analyticsUtag";

const ProductCarousel = (props) => {
  const isMobile = componentCheckSize() <= 576;
  const isTablet = 576 < componentCheckSize() <= 992;
  const isTabletLandscape = componentCheckSize() > 992;
  const tabProducts = props?.ProductCarouselData;
  const [carouselData, setCarouselData] = useState([]);
  const [previousNavClass, setPreviousNavClass] = useState("");
  const [nextNavClass, setNextNavClass] = useState("");
  const asyncData = [];
  const windowWidth = componentCheckSize();
  const hideButtons = props.hideButtons
    ? !isMobile && !props.hideButtons
    : false;
  let [centerValue, setCenterValue] = useState(false);

  useEffect(() => {
    async function getCarouselData() {
      const totalProducts = tabProducts?.length;
      for (let i = 0; i < totalProducts; i++) {
        productCarouselService(tabProducts[i].sku).then((result) => {
          result = result.products;
          result = result.items;
          asyncData.push(result[0]);
          if (asyncData.length === totalProducts) {
            setCarouselData(asyncData);
          }
        });
      }
    }
    if (tabProducts.length < 1) {
      getCarouselData();
    }
  }, []);
  let productCarousel;
  const next = () => {
    if (productCarousel) {
      productCarousel.next(600);
    }
  };
  const prev = () => {
    if (productCarousel) {
      productCarousel.prev(600);
    }
  };

  const deviceOptions = {
    nav: true,
    autoplay: false,
    animateIn: "animate__fadeIn",
    autoWidth: false,
    lazyLoad: true,
    navContainerClass: "owl--nav--container",
    dotsClass: "owl--dots owl--dots-space",
    dotClass: "owl--dot",
    loop: false,
    responsive: {
      0: {
        dots: true,
        autoWidth: false,
        items: 1,
        mouseDrag: true,
        touchDrag: true,
        // center: false,
        slideBy: 1,
        margin: 16,
      },
      360: {
        dots: true,
        items: 1,
        autoWidth: true,
        slideBy: 1,
        center: centerValue,
        margin: 16,
      },
      375: {
        dots: true,
        items: 1,
        autoWidth: true,
        slideBy: 1,
        center: centerValue,
        margin: 16,
      },

      768: {
        dots: tabProducts.length > (props.isDeal ? 3 : 4),
        items: props.isDeal ? 3 : 4,
        slideBy: props.isDeal ? 2 : 3,
        // autoWidth: true,
        slideBy: 1,
        margin: 16,
        // center:false
      },
      992: {
        dots: tabProducts.length > (props.isDeal ? 3 : 4),
        items: props.isDeal ? 3 : 4,
        slideBy: props.isDeal ? 3 : 4,
        margin: 16,
        // center:false
      },
      1200: {
        dots: tabProducts.length > (props.isDeal ? 3 : 4),
        items: props.isDeal ? 3 : 4,
        slideBy: props.isDeal ? 3 : 4,
        margin: 16,
        // center:false
      },
      1280: {
        dots: tabProducts.length > (props.isDeal ? 4 : 5),
        margin: 16,
        // center:false,
        items: props.isDeal ? 4 : 5,
        slideBy: props.isDeal ? 2 : 5,
      },
    },
  };
  const events = {
    onInitialized: function (event) {
      toggleCarouselNavDisabled(event);
    },
    onTranslated: function (event) {
      toggleCarouselNavDisabled(event);
    },
  };

  function toggleCarouselNavDisabled(event) {
    const index = event.item.index;
    if (
      (props?.carouselId == "shop-deal-carousel" && index > 0) ||
      (props?.carouselId == "shop-product-carousel" && index > 0)
    ) {
      setCenterValue(true);
    } else {
      setCenterValue(false);
    }
    const minimum = 0;
    const maximum = event.item.count;
    let idx = index;
    let previousNav = index <= minimum ? "disabled" : "";

    if (
      (isTablet && isTabletLandscape && !isMobile) ||
      (!props.isDeal && isTablet)
    ) {
      idx = index + 2;
    } else if (isTablet && !isTabletLandscape && !isMobile) {
      idx = index + 1;
    } else {
      let idx = index;
    }

    let nextNav =
      index +
        deviceOptions.responsive[event.relatedTarget._breakpoint].slideBy >=
      maximum
        ? "disabled"
        : "";
    setPreviousNavClass(previousNav);
    setNextNavClass(nextNav);
  }

  const generateSize = () => {
    let dealDisplay = 1;
    let productDisplay = 1;
    if (windowWidth > 768 && windowWidth < 1200) {
      dealDisplay = 3;
      productDisplay = 4;
    } else if (windowWidth >= 1200 && windowWidth < 1400) {
      dealDisplay = 3;
      productDisplay = 4;
    } else if (windowWidth >= 1400) {
      dealDisplay = 4;
      productDisplay = 5;
    }
    let displaySize = props.isDeal ? dealDisplay : productDisplay;
    return displaySize;
  };
  const displayData = props.id ? carouselData : tabProducts;

  const handleBuyNow = (product, index) => {
    const analyticsViewData = Analytics.getUtagData([
      "page_name",
      "page_channel",
      "page_master_tab",
      "visitor_login_status",
      "visitor_msisdn_hash",
      "visitor_customer_id",
      "visitor_id_hash",
      "visitor_subscription_type",
      "page_site_section_lvl_1",
      "page_site_section_lvl_2",
      "page_site_section_lvl_3",
      "page_site_section_lvl_4",
    ]);
    const analyticsData = {
      link_type: "o",
      link_name: `${analyticsViewData.page_name}: product p${index + 1}: ${
        product.name
      }${props.tabName ? ": " + props.tabName : ""}`,
      sales_product_category: [product?.categories?.[0]?.name],
      sales_product_id: [product?.name],
      sales_product_price: [getFinalPrice(product)],
      sales_product_quantity: [1],
    };
    if (product?.badges_label) {
      analyticsData.sales_promo_name = [product?.badges_label];
    }
    if (product?.deal_end_date) {
      analyticsData.deal_expiry = getDealExpiryTime(product?.deal_end_date);
    }
    Analytics.link({
      ...analyticsViewData,
      ...analyticsData,
    });
  };

  const centerAlign = () => {
    if (props?.alignment && props?.alignment.toLowerCase() === "center") {
      return "product-carousel-center";
    }
    return "";
  };

  const contentStyle =
    props?.displayStyle !== "Grid"
      ? `product-carousel ${styles["custom-container"]} ${
          styles[
            props?.alignment
              ? `custom-styles-${props.alignment}`
              : Number(displayData.length) < Number(generateSize()) &&
                styles["center-styles"]
          ]
        } ${centerAlign()} ${
          tabProducts.length <= (props?.isDeal ? 2 : 3) && "tab-carousel"
        }`
      : `${styles["grid-container"]} ${
          isMobile ? styles["grid-container__mobile"] : ""
        }`;

  const Wrapper =
    props?.displayStyle !== "Grid"
      ? OwlCarousel
      : ({ children }) => <>{children}</>;

  return (
    <>
      {displayData?.length > 0 && (
        <>
          <div className={contentStyle}>
            {Number(displayData?.length) > Number(generateSize()) &&
              !hideButtons &&
              props?.displayStyle !== "Grid" &&
              !isMobile && (
                <div className={styles["custom-container-button"]}>
                  <CarouselButton
                    prev
                    className={`${
                      previousNavClass ? styles["disabled"] : styles["prev-btn"]
                    }`}
                    handleClick={prev}
                    variant={!isTablet ? "oval" : ""}
                    id={
                      props.isDeal
                        ? "ProductCarousel_arrowBackBtn-deal"
                        : "ProductCarousel_arrowBackBtn"
                    }
                  />
                  <CarouselButton
                    next
                    className={`${
                      nextNavClass ? styles["disabled"] : styles["next-btn"]
                    }`}
                    handleClick={next}
                    variant={!isTablet ? "oval" : ""}
                    id={
                      props.isDeal
                        ? "ProductCarousel_arrowNextBtn-deal"
                        : "ProductCarousel_arrowNextBtn"
                    }
                  />
                </div>
              )}
            <Wrapper
              ref={(c) => (productCarousel = c)}
              options={deviceOptions}
              events={events}
            >
              {displayData.map((item, index) => (
                <div
                  className={
                    !props.isSearch
                      ? `d-flex ${styles["carousel-container"]} tab-item ${
                          styles[props.isDeal && "margin-style"]
                        }`
                      : `${styles["carousel-container"]} tab-item ${
                          styles[props.isDeal && "margin-style"]
                        }`
                  }
                  key={index}
                >
                  {props.isDeal ? (
                    <DealCard
                      width="100%"
                      height="32.938rem"
                      img_width="10rem"
                      maxHeight="33.5rem"
                      img_height="10rem"
                      width_mobile="17.5rem"
                      height_mobile="29.313rem"
                      img_width_mobile="7.5rem"
                      img_height_mobile="7.5rem"
                      productName={item?.name}
                      availableIn={props?.availableIn}
                      endsIn={props?.endsIn}
                      imgUrl={getProductImageUrl(item, "image", "No_image")}
                      imgUrl_mobile={getProductImageUrl(
                        item,
                        "small_image",
                        "No_image_1"
                      )}
                      isOutOfStock={checkIsOutOfStock(item)}
                      saveLabel={
                        item?.price_range?.minimum_price?.discount
                          ?.amount_off != 0 &&
                        item?.price_range?.minimum_price?.discount?.amount_off
                      }
                      promotionLabel={item?.promotion_tag !=null ? getPromotionLabel(item) : ''}
                      promotionVariant={getPromotionVariant(item)}
                      promotionLabelColor={
                        getPromotionLabel(item) === item?.promotion_tag_label
                          ? item.promotion_tag_swatch
                          : item?.badges_swatch
                          ? item.badges_swatch
                          : null
                      }
                      planName={
                        item.package_description ? item.package_description : ""
                      }
                      highlights={getHighlights(item)}
                      originalPrice={
                        item?.monthly_recurring ? item.monthly_recurring : ""
                      }
                      offerPrice={
                        item?.monthly_recurring ? item.monthly_recurring : ""
                      }
                      prevPrice={
                        item?.old_monthly_recurring
                          ? item.old_monthly_recurring
                          : ""
                      }
                      numberOfMonths={item?.payment_terms_label}
                      buttonText={labels.lbl_see_details}
                      buttonHandler={props.navigateTo}
                      deal_end_date={item?.deal_end_date}
                      deal_go_live_date={item?.deal_go_live_date}
                      deal_label={item?.deal_label}
                      is_deal_locked={item?.is_deal_locked}
                      item={item}
                      id={item?.sku}
                      className={props.campaignFlag && "card-style"}
                      campaignFlag={props.campaignFlag}
                    />
                  ) : (
                    <ProductCards
                      priceRequired
                      className={`${styles["custom-styles-carousel"]} pb-0`}
                      finalPriseAlignmiddle={true}
                      promotionLabel={item?.promotion_tag != null ? getPromotionLabel(item) : ''}
                      promotionVariant={getPromotionVariant(item)}
                      promotionLabelColor={
                        getPromotionLabel(item) === item?.promotion_tag_label
                          ? item.promotion_tag_swatch
                          : item?.badges_swatch
                          ? item.badges_swatch
                          : null
                      }
                      maximumPrice={
                        item?.price_range?.maximum_price?.regular_price?.value
                      }
                      minimumPrice={
                        getAmountOffValue(item) === "0"
                          ? getFinalPrice(item) !== "0"
                            ? getFinalPrice(item)
                            : getRegularPrice(item)
                          : getRegularPrice(item)
                      }
                      isLowStock={checkIsLowStock(item)}
                      isOutOfStock={checkIsOutOfStock(item)}
                      finalPriceReq={checkIsFinalPriceReq(item)}
                      finalPrice={getFinalPrice(item)}
                      percentOff={getPercentOffValue(item)}
                      amountOff={getAmountOffValue(item)}
                      offerStyle={styles["offer-style"]}
                      priceLabelProductStyle={styles["price-label-style"]}
                      itemName={item?.name}
                      buyNowReq
                      itemImage={item?.image.url}
                      buttonLabelReq={labels.lbl_buy_now}
                      previousPriceReq
                      sku={item?.sku}
                      switchReq={props.isSearch}
                      isPrepaidOnly={
                        item?.bundle_product_price === null ||
                        item?.bundle_product_price === undefined
                      }
                      dealProductPrice={item?.bundle_product_price}
                      switchClass="product-carousel"
                      cardWidth={
                        isTabletLandscape ? props.width : props.width_mobile
                      }
                      imgWidth={
                        isTabletLandscape
                          ? props.img_width
                          : props.img_width_mobile
                      }
                      imgHeight={
                        isTabletLandscape
                          ? props.img_height
                          : props.img_height_mobile
                      }
                      priceLabelClassName={styles["card-price-height"]}
                      deal_end_date={item?.deal_end_date}
                      deal_go_live_date={item?.deal_go_live_date}
                      deal_label={item?.deal_label}
                      is_deal_locked={item?.is_deal_locked}
                      item={item}
                      id={item?.sku}
                      availableIn={props?.availableIn}
                      endsIn={props?.endsIn}
                      ctaHandler={() => handleBuyNow(item, index)}
                    />
                  )}
                </div>
              ))}
            </Wrapper>
          </div>
        </>
      )}
    </>
  );
};

export default ProductCarousel;
